/** Medium date for admin filter chips (e.g. Jan 15, 2024). date-fns pattern. */
export const FILTER_CHIP_DATE_FORMAT = 'MMM d, yyyy'
